// File: noviopus-ats-client/src/features/Account/accountSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountState, UpdateAccountPayload, Account } from './types';

export const initialState: AccountState = {
  data: null,
  loading: false,
  error: null,
  saveStatus: 'idle',
  stats: null,
};

const accountSlice = createSlice({
  name: 'accountFeature', 
  initialState,
  reducers: {
    // --- Set Account Data ---
    setAccountData: (state, action: PayloadAction<Account | null>) => {
        state.data = action.payload;
    },

    // Update
    updateAccount: (state, action: PayloadAction<UpdateAccountPayload>) => {
      state.loading = true;
      state.saveStatus = 'saving';
      state.error = null;
    },
    updateAccountSuccess: (state, action: PayloadAction<Account>) => {
      state.loading = false;
      state.saveStatus = 'success';
      state.data = action.payload; // Update local state immediately
    },
    updateAccountFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.saveStatus = 'error';
      state.error = action.payload;
    },
    
    // Stats
    fetchStats: (state, action: PayloadAction<string>) => {
        state.loading = true;
    },
    fetchStatsSuccess: (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.stats = action.payload;
    },

    // Status Actions
    activateAccount: (state, action: PayloadAction<string>) => {
        state.loading = true;
    },
    pauseAccount: (state, action: PayloadAction<string>) => {
        state.loading = true;
    },
    statusChangeSuccess: (state) => {
        state.loading = false;
    },

    resetAccountStatus: (state) => {
      state.saveStatus = 'idle';
      state.error = null;
      state.loading = false;
    }
  },
});

export const {
  setAccountData,
  updateAccount,
  updateAccountSuccess,
  updateAccountFailure,
  fetchStats,
  fetchStatsSuccess,
  activateAccount,
  pauseAccount,
  statusChangeSuccess,
  resetAccountStatus
} = accountSlice.actions;

export default accountSlice.reducer;